import React, { createContext, useContext, useEffect, useState } from "react"
import { FMFile } from "../shared/FMFile"
import { usePath } from "../libs/path/PathProvider"
import Files from "./Files"
import Utils from "../libs/Utils"
import { useSnackbar } from "../gui/Snackbar/SnackbarProvider"
export type TFilesProviderContext = {
    files?:FMFile[]
    root:FMFile|undefined
}

const FileProviderContext = createContext<TFilesProviderContext>({} as any)
export const useFilesProvider = () => useContext(FileProviderContext)

export default function FilesProvider(props:{children:React.ReactNode}) {
    const [root,setRoot] = useState<FMFile|undefined>()
    const [files,setFiles] = useState<FMFile[]|undefined>()
    const {path,setPath} = usePath()
    const {addSnackbar} = useSnackbar()
    
    const getRootId = () => path.split("/")[1] || "0"

    const loadFiles = async (id:string) => {
        try {
            setFiles(undefined)
            const file = await Files.i.get(id)
            setRoot(file)
            setFiles(await Files.i.getBatch(file.childIds||[]))
        }catch(e){
            addSnackbar(e)
            setFiles([])
            if (Utils.httpStatus(e)==404) setPath("/")
        }
    }
    const onRefresh = (id:string,file:FMFile) => id==getRootId() && loadFiles(id)
    useEffect(() => {
        setFiles(undefined)
        loadFiles(getRootId())
        Files.i.on("update", onRefresh)
        return () => { Files.i.removeListener("update", onRefresh)}
    }, [path])

    return <FileProviderContext.Provider value={{root,files}}>{props.children}</FileProviderContext.Provider>
}